<template>
    <div class>
        <div class="section has-background-white has-text-centered">
            <p
                v-t="'Community.calendar'"
                class="is-size-4 has-text-primary mt-1 has-text-weight-bold"
            />
            <button
                v-if="isAdmin"
                v-t="'Community.create_event'"
                class="button is-pink-red has-shadow is-pulled-right is-relative"
                style="bottom: 3rem"
                @click="createEvent()"
            />
        </div>

        <app-calendar
            :calendar-events="calendarEvents"
            :saving-changes="savingChanges"
            class="section pt-0"
            @viewEvent="viewEvent"
        ></app-calendar>

        <CommunityCalendarEvent
            v-if="newEvent"
            :event="currentEvent"
            :saving-changes="savingChanges"
            :editing="editing"
            @saveChanges="saveChanges"
            @close="
                newEvent = false;
                currentEvent = {};
                editing = false;
            "
        />

        <CommunityCalendarEventView
            v-if="showEvent"
            :event="currentEvent"
            @edit="
                showEvent = false;
                newEvent = true;
                editing = true;
            "
            @close="
                showEvent = false;
                currentEvent = {};
            "
            @delete="removeEvent"
        />
    </div>
</template>
<script>
import AppCalendar from '@/components/AppCalendar';
import CommunityCalendarEvent from '@/components/CommunityCalendarEvent';
import CommunityCalendarEventView from '@/components/CommunityCalendarEventView';
const nanoid = require('nanoid');
import {
    addCommunityCalendarEvent,
    updateCommunityCalendarEvent,
    deleteCommunityCalendarEvent,
} from '@/services/API';
import _ from 'underscore';

export default {
    components: {
        AppCalendar,
        CommunityCalendarEvent,
        CommunityCalendarEventView,
    },
    data() {
        return {
            savingChanges: false,
            //activeEvents: [],
            newEvent: false,
            showEvent: false,
            currentEvent: {},
            editing: false,
        };
    },
    computed: {
        calendarEvents() {
            const sourceEvents = _.sortBy(
                this.$store.getters.communityEvents,
                function (e) {
                    return e.range.start;
                }
            );
            const activeEvents = [];
            sourceEvents.forEach((element) => {
                activeEvents.push({
                    key: element._id,
                    customData: {
                        title: element.title,
                        class: element.color + ' text-white',
                    },
                    dates: element.range.start,
                });
            });
            // console.log("activeEvents",activeEvents)
            return activeEvents;
        },
        community() {
            return this.$store.getters.community;
        },
        isAdmin() {
            return this.community.accessLevel == 'administrator';
        },
    },
    mounted() {
        this.$store.dispatch(
            'fetchCommunityCalendar',
            this.$route.params.communityId
        );
    },
    metaInfo() {
        return {
            title: this.$t(`Community.calendar`) + ' - ' + this.community.title,
            titleTemplate: '%s - Labylok',
        };
    },
    methods: {
        async saveChanges(event) {
            this.savingChanges = true;
            if (!event.title) {
                this.savingChanges = false;
                return this.$toast.error(this.$t('Error.MISSING_EVENT_TITLE'), {
                    timeout: 2000,
                });
            }
            if (!event.range) {
                this.savingChanges = false;
                return this.$toast.error(this.$t('Error.MISSING_EVENT_DATES'), {
                    timeout: 2000,
                });
            }
            if (event._id) {
                const result = await updateCommunityCalendarEvent(
                    this.$store.getters.community._id,
                    event
                )
                    .then((e) => {
                        if (!e.data._id) {
                            this.savingChanges = false;
                            return;
                        }
                        this.savingChanges = false;
                        this.newEvent = false;
                        this.currentEvent = {};

                        this.$store.commit('UPDATE_COMMUNITY_EVENT', e.data);
                    })
                    .catch((err) => {
                        this.$toast.error(this.$t('Error.' + err.data), {
                            timeout: 2000,
                        });
                        this.savingChanges = false;
                    });
            } else {
                const result = await addCommunityCalendarEvent(
                    this.$store.getters.community._id,
                    event
                )
                    .catch((err) => {
                        this.savingChanges = false;
                        return this.$toast.error(this.$t('Error.' + err.data), {
                            timeout: 2000,
                        });
                    })
                    .then((e) => {
                        if (!e.data._id) {
                            this.savingChanges = false;
                            return;
                        }
                        this.savingChanges = false;
                        this.newEvent = false;
                        this.currentEvent = {};
                        this.$store.commit('SET_COMMUNITY_EVENT', e.data);
                    });
            }
        },
        async removeEvent(event) {
            if (
                confirm(
                    this.$t(
                        'Community.delete_calendar_event_confirmation_message'
                    )
                )
            ) {
                await deleteCommunityCalendarEvent(
                    this.$store.getters.community._id,
                    event._id
                ).then((e) => {
                    this.showEvent = false;
                    this.currentEvent = {};
                    this.$store.commit('REMOVE_COMMUNITY_EVENT', event);
                });
            }
        },
        viewEvent(calendarEvent) {
            this.currentEvent = _.findWhere(
                this.$store.getters.communityEvents,
                {
                    _id: calendarEvent.key,
                }
            );
            this.showEvent = true;
        },
        createEvent() {
            this.currentEvent = {
                title: null,
                range: {
                    start: new Date(),
                    end: new Date(),
                },
                color: 'bg-blue-500',
                share: 'NONE',
            };
            this.newEvent = true;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../assets/css/community.css';
</style>
